__turbopack_context__.v({
  "addReviewContainer": "AddReviewBanner-module-scss-module__rLu_KG__addReviewContainer",
});
